<small class="debug">{{ me }}</small>
<div appPreventPullToRefresh>
    @switch (viewMode) {
        @case (EnumViewMode.NOT_LOGGED_IN) {
            <div translate="no" fxLayout="column" fxLayoutAlign="center center" style="padding-top: 50px"
                 fxLayoutGap="0px">
                <img style="width: 130px; padding-bottom: 30px" src="./assets/police_israel_logo.png" />
                <div fxLayout="row" fxLayoutGap="1px" fxLayoutAlign="center center">
                    <mat-label style="font-size: 2em">קוד כניסה</mat-label>
                </div>
                <br />
                <div fxLayout="row" fxLayoutGap="1px" fxLayoutAlign="center center">
                    <mat-form-field
                        appearance="outline"
                        color="warn"
                        *ngFor="let control of inputControls; let i = index"
                        class="otp-form-field"
                    >
                        <input
                            style="font-size: 2em"
                            class="otp-input shake-input"
                            matInput
                            [disabled]="isDisabledLogin"
                            maxlength="1"
                            type="text"
                            (input)="onInput($event, i)"
                            (keyup)="onLoginCheck()"
                            (keydown.backspace)="onBackspace($event, i)"
                            [(ngModel)]="inputValues[i]"
                            #inputBox
                        />
                    </mat-form-field>
                </div>
                <div style="text-align: center">
                    <div mat-dialog-actions style="justify-content: center">
                        <button mat-icon-button (click)="clearInputs()">
                            <mat-icon class="mat-icon-large">highlight_off</mat-icon>
                        </button>
                    </div>
                    <br />
                </div>
                <br />
                <br />
                <div fxLayout="column" fxLayoutAlign="center center" style="opacity: 0.5">
                    <mat-label style="padding-top: 5px">
                        נגזרת על פי נוהל מספר 02.220.202
                    </mat-label>
                </div>
                <br />
                <br />
                <mat-label style="padding-top: 5px">
                    version {{ version }}
                </mat-label>
                <br />
                <button mat-button style="opacity: 0.1" (click)="clearPwa()">
                    clear settings
                </button>
                <br />
            </div>
        }
        @case (EnumViewMode.CHECKING_1) {
            <div
                translate="no"
                fxLayout="column"
                fxLayoutAlign="center center"
                style="padding-top: 50px"
                fxLayoutGap="0px"
            >
                <img
                    style="height: 130px; padding-bottom: 30px"
                    src="./assets/police_israel_logo.png"
                />
                <!-- קוד קריאה -->
                <mat-form-field
                    appearance="fill"
                    class="entry1 form-element field-wide"
                >
                    <mat-label style="font-size: 1.2em">קוד קריאה</mat-label>
                    <span
                        matPrefix
                        class="equipment-emoji"
                        aria-label="call code"
                        role="img"
                    >
			📟
			</span>
                    <mat-select
                        (selectionChange)="checkStartCheckReady();isDebugModeCodeCall()" [(ngModel)]="selectedCodeCall">
                        <mat-option *ngFor="let lev of callIds" [value]="lev">
                            <mat-label style="font-size: 1.2em">{{ lev }}</mat-label>
                        </mat-option>
                    </mat-select>
                </mat-form-field>
                <!-- שם פרטי -->
                <mat-form-field
                    appearance="fill"
                    class="entry1 form-element field-wide"
                >
                    <mat-label class="entryPolice">שם פרטי</mat-label>
                    <span
                        matPrefix
                        class="equipment-emoji"
                        aria-label="user name"
                        role="img"
                    >
			👤
			</span>
                    <input
                        (keyup)="checkStartCheckReady()"
                        [(ngModel)]="userName"
                        style="font-size: 1.8em"
                        matInput
                        type="text"
                        name="SearchDualList"
                        class="entryPolice form-control"
                        autocomplete="off"
                    />
                    <a
                        (click)="userName = ''; checkStartCheckReady()"
                        matSuffix
                        aria-label="Clear"
                    >
                        <mat-icon>close</mat-icon>
                    </a>
                </mat-form-field>
                <!-- מספר ניידת -->
                <mat-form-field
                    appearance="fill"
                    class="entry1 form-element field-wide"
                >
                    <mat-label style="font-size: 1.2em">מספר ניידת</mat-label>
                    <span
                        matPrefix
                        class="equipment-emoji"
                        aria-label="police car"
                        role="img"
                    >
			🚓
			</span>
                    <mat-select
                        (selectionChange)="onSelectedVehicle(); checkStartCheckReady()"
                        [(ngModel)]="selectedVehicle"
                    >
                        <mat-option
                            *ngFor="let vehicle of vehicles"
                            [value]="vehicle"
                        >
                            <mat-label style="font-size: 1.2em">{{ vehicle.id }}</mat-label>
                        </mat-option>
                    </mat-select>
                </mat-form-field>
                <!-- ראש משמרת -->
                <mat-form-field
                    appearance="fill"
                    class="entry1 form-element field-wide"
                >
                    <mat-label style="font-size: 1.1em">ראש משמרת</mat-label>
                    <span
                        matPrefix
                        class="equipment-emoji"
                        aria-label="shift commander"
                        role="img"
                    >
			👮‍♂️
			</span>
                    <mat-select
                        (selectionChange)="onSelectedCaptain(); checkStartCheckReady()"
                        [(ngModel)]="selectedCaptain"
                    >
                        <mat-option
                            *ngFor="let item of emailSendTo"
                            [value]="item"
                        >
                            <mat-label style="font-size: 1.2em">{{ item.name }}</mat-label>
                        </mat-option>
                    </mat-select>
                </mat-form-field>
                <!-- מספר אישי -->
                <mat-form-field
                    appearance="fill"
                    class="entry1 form-element field-wide"
                >
                    <mat-label class="entryPolice">מספר אישי</mat-label>
                    <span
                        matPrefix
                        class="equipment-emoji"
                        aria-label="badge number"
                        role="img"
                    >
			🆔
			</span>
                    <input
                        (keyup)="checkStartCheckReady()"
                        [(ngModel)]="officerId"
                        style="font-size: 1.8em"
                        inputrestriction="numbers"
                        matInput
                        type="number"
                        name="SearchDualList"
                        class="entryPolice form-control"
                        autocomplete="off"
                    />
                    <a
                        (click)="officerId = ''; checkStartCheckReady()"
                        matSuffix
                        aria-label="Clear"
                    >
                        <mat-icon>close</mat-icon>
                    </a>
                </mat-form-field>
                <div class="helpEquipment" fxLayout="column" fxLayoutAlign="center center">
                    <button
                        style="width: 175px"
                        [disabled]="startCheckDisabled"
                        mat-raised-button
                        color="warn"
                        (click)="start()"
                    >
                        המשך
                    </button>
                    <br />
                    <br />
                    <div style="position: relative; left: 15px;width: 200px">
                        <mat-checkbox [(ngModel)]="kitatKonenut" (change)="setKitatKonenoot($event)">
                            <mat-label class="sliderLabel">כיתת כוננות</mat-label>
                        </mat-checkbox>
                    </div>
                    <br />
                    <button mat-stroked-button style="width: 175px" (click)="installPwa()">
                        הורדת האפליקציה
                        <mat-icon style="position: relative; left: -4px">get_app</mat-icon>
                    </button>
                    <br />
                </div>
                <br />
                <mat-label style="padding-top: 5px">
                    version {{ version }}
                </mat-label>
                <br />
                <button
                    mat-button
                    style="opacity: 0.1"
                    (click)="clearPwa()"
                >
                    clear settings
                </button>
            </div>
        }
        @case (EnumViewMode.CHECKING_2) {
            <form [formGroup]="form" (focusout)="allControlsAllWizardsCheck()">
                <mat-horizontal-stepper linear #stepper (animationDone)="createReport()">
                    <mat-step [completed]="!wizardDisabled1" [editable]="true">
                        <ng-template matStepLabel> ציוד אישי</ng-template>
                        <div translate="no" fxLayout="row" fxLayoutAlign="center center">
                            <!-- Replace the first section in your CHECKING_2 case with this: -->
                            <!-- Replace your existing equipment section with this updated version: -->
                            <section class="example-section equipment-container" style="padding-right: 30px">
                                <div fxLayout="column" fxLayoutAlign="center center"
                                     class="equipment-dropdowns-container">

                                    <!-- תיקיות - New Checkbox (goes on top) -->
                                    <div class="tik-container" style="padding: 10px;">
                                        <mat-checkbox
                                            formControlName="תיקיות"
                                            (change)="onTikiyotChange($event); allControlsTouchedPage1('תיקיות')"
                                            [ngClass]="{'error-border-wrapper': !form.controls['תיקיות'].touched}"
                                        >
                <span
                    class="equipment-emoji"
                    aria-label="bags kit"
                    role="img"
                    style="margin-right: 8px;">
                    📁
                </span>
                                            <mat-label class="sliderLabel" style="font-size: 1.2em;">תיקיות</mat-label>
                                        </mat-checkbox>

                                    </div>

                                    <!-- Fixed height container for conditional bag dropdowns -->
                                    <div class="conditional-bags-container">
                                        <!-- תיק מחסומים -->
                                        <mat-form-field
                                            *ngIf="tikiyotSelected"
                                            appearance="fill"
                                            class="entry1 form-element field-wide conditional-field"
                                            [ngClass]="{'error-border': !form.controls['תיק_מחסומים'].touched}"
                                        >
                                            <mat-label style="font-size: 1.2em">תיק מחסומים</mat-label>
                                            <span
                                                matPrefix
                                                class="equipment-emoji"
                                                aria-label="barrier kit"
                                                role="img"
                                            >
                    🚧
                </span>
                                            <mat-select
                                                formControlName="תיק_מחסומים"
                                                (selectionChange)="allControlsTouchedPage1('תיק_מחסומים'); checkStartCheckReady()"
                                                [ngClass]="{
                      'error-border': form.controls['תיק_מחסומים'].invalid && form.controls['תיק_מחסומים'].touched
                    }"
                                            >
                                                <mat-option *ngFor="let item of ['0','1']" [value]="item">
                                                    <mat-label style="font-size: 1.2em">{{ item }}</mat-label>
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>

                                        <!-- תיק סיור -->
                                        <mat-form-field
                                            *ngIf="tikiyotSelected"
                                            appearance="fill"
                                            class="entry1 form-element field-wide conditional-field"
                                            [ngClass]="{'error-border': !form.controls['תיק_סיור'].touched}"
                                        >
                                            <mat-label style="font-size: 1.2em">תיק סיור</mat-label>
                                            <span
                                                matPrefix
                                                class="equipment-emoji"
                                                aria-label="patrol kit"
                                                role="img"
                                            >
                    🧳
                </span>
                                            <mat-select
                                                formControlName="תיק_סיור"
                                                (selectionChange)="allControlsTouchedPage1('תיק_סיור'); checkStartCheckReady()"
                                                [ngClass]="{
                      'error-border': form.controls['תיק_סיור'].invalid && form.controls['תיק_סיור'].touched
                    }"
                                            >
                                                <mat-option *ngFor="let item of ['0','1']" [value]="item">
                                                    <mat-label style="font-size: 1.2em">{{ item }}</mat-label>
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>

                                        <!-- תיק שטח -->
                                        <mat-form-field
                                            *ngIf="tikiyotSelected"
                                            appearance="fill"
                                            class="entry1 form-element field-wide conditional-field"
                                            [ngClass]="{'error-border': !form.controls['תיק_שטח'].touched}"
                                        >
                                            <mat-label style="font-size: 1.2em">תיק שטח</mat-label>
                                            <span
                                                matPrefix
                                                class="equipment-emoji"
                                                aria-label="field kit"
                                                role="img"
                                            >
                    📂
                </span>
                                            <mat-select
                                                formControlName="תיק_שטח"
                                                (selectionChange)="allControlsTouchedPage1('תיק_שטח'); checkStartCheckReady()"
                                                [ngClass]="{
                      'error-border': form.controls['תיק_שטח'].invalid && form.controls['תיק_שטח'].touched
                    }"
                                            >
                                                <mat-option *ngFor="let item of ['0','1']" [value]="item">
                                                    <mat-label style="font-size: 1.2em">{{ item }}</mat-label>
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </div>

                                    <!-- תיק פיזור - Checkbox -->
                                    <div class="tik-pizor-container" style="padding: 10px;">
                                        <mat-checkbox
                                            formControlName="תיק_פיזור"
                                            (change)="onTikPizorChange($event); allControlsTouchedPage1('תיק_פיזור')"
                                            [ngClass]="{'error-border-wrapper': !form.controls['תיק_פיזור'].touched}"
                                        >
                <span
                    class="equipment-emoji"
                    aria-label="dispersion kit"
                    role="img"
                    style="margin-right: 8px;">
                    🎒
                </span>
                                            <mat-label class="sliderLabel" style="font-size: 1.2em;">תיק פיזור
                                            </mat-label>
                                        </mat-checkbox>
                                    </div>

                                    <!-- Fixed height container for conditional dropdowns -->
                                    <div class="conditional-equipment-container">
                                        <!-- אפוד קרמי -->
                                        <mat-form-field
                                            *ngIf="tikPizorSelected"
                                            appearance="fill"
                                            class="entry1 form-element field-wide conditional-field"
                                            [ngClass]="{'error-border': !form.controls['אפוד_קרמי'].touched}"
                                        >
                                            <mat-label style="font-size: 1.2em">אפוד קרמי</mat-label>
                                            <span
                                                matPrefix
                                                class="equipment-emoji"
                                                aria-label="ballistic vest"
                                                role="img"
                                            >
                    🎽
                </span>
                                            <mat-select
                                                formControlName="אפוד_קרמי"
                                                (selectionChange)="allControlsTouchedPage1('אפוד_קרמי'); checkStartCheckReady()"
                                            >
                                                <mat-option *ngFor="let item of ['0','1','2']" [value]="item">
                                                    <mat-label style="font-size: 1.2em">{{ item }}</mat-label>
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>

                                        <!-- אפוד מגן -->
                                        <mat-form-field
                                            *ngIf="tikPizorSelected"
                                            appearance="fill"
                                            class="entry1 form-element field-wide conditional-field"
                                            [ngClass]="{'error-border': !form.controls['אפוד_מגן'].touched}"
                                        >
                                            <mat-label style="font-size: 1.2em">אפוד מגן</mat-label>
                                            <span
                                                matPrefix
                                                class="equipment-emoji"
                                                aria-label="protective vest"
                                                role="img"
                                            >
                    🛡️
                </span>
                                            <mat-select
                                                formControlName="אפוד_מגן"
                                                (selectionChange)="allControlsTouchedPage1('אפוד_מגן'); checkStartCheckReady()"
                                                [ngClass]="{
                      'error-border': form.controls['אפוד_מגן'].invalid &&
                                     form.controls['אפוד_מגן'].touched
                    }"
                                            >
                                                <mat-option *ngFor="let item of ['0','1','2']" [value]="item">
                                                    <mat-label style="font-size: 1.2em">{{ item }}</mat-label>
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>

                                        <!-- קסדה -->
                                        <mat-form-field
                                            *ngIf="tikPizorSelected"
                                            appearance="fill"
                                            class="entry1 form-element field-wide conditional-field"
                                            [ngClass]="{'error-border': !form.controls['קסדה'].touched}"
                                        >
                                            <mat-label style="font-size: 1.2em">קסדה</mat-label>
                                            <span
                                                matPrefix
                                                class="equipment-emoji"
                                                aria-label="helmet"
                                                role="img"
                                            >
                    🪖
                </span>
                                            <mat-select
                                                formControlName="קסדה"
                                                (selectionChange)="allControlsTouchedPage1('קסדה'); checkStartCheckReady()"
                                                [ngClass]="{
                      'error-border': form.controls['קסדה'].invalid && form.controls['קסדה'].touched
                    }"
                                            >
                                                <mat-option *ngFor="let item of ['0','1','2']" [value]="item">
                                                    <mat-label style="font-size: 1.2em">{{ item }}</mat-label>
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>

                                        <!-- אלה -->
                                        <mat-form-field
                                            *ngIf="tikPizorSelected"
                                            appearance="fill"
                                            class="entry1 form-element field-wide conditional-field"
                                            [ngClass]="{'error-border': !form.controls['אלה'].touched}"
                                        >
                                            <mat-label style="font-size: 1.2em">אלה</mat-label>
                                            <span
                                                matPrefix
                                                class="equipment-emoji"
                                                aria-label="baton"
                                                role="img">
                    🦯
                </span>
                                            <mat-select
                                                formControlName="אלה"
                                                (selectionChange)="allControlsTouchedPage1('אלה'); checkStartCheckReady()"
                                                [ngClass]="{
                      'error-border': form.controls['אלה'].invalid && form.controls['אלה'].touched
                    }"
                                            >
                                                <mat-option *ngFor="let item of ['0','1','2']" [value]="item">
                                                    <mat-label style="font-size: 1.2em">{{ item }}</mat-label>
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </div>

                                </div>
                            </section>
                            <!-- Second Section -->
                            <section class="example-section">
                                <!-- מספר קשר (א) -->
                                <mat-form-field
                                    appearance="fill"
                                    class="form-element field-wide"
                                >
                                    <mat-label style="font-size: 1.2em">*קשר (א)</mat-label>
                                    <span
                                        matPrefix
                                        class="equipment-emoji"
                                        aria-label="radio number"
                                        role="img"
                                    >
					<fa-icon
                        size="2x"
                        class="fa-lg-icon"
                        style="color: #000000;"
                        [icon]="faWalkieTalkie"
                    ></fa-icon>
				</span>
                                    <input
                                        (focusout)="form.controls['מספר_קשר1'].markAsTouched(); allControlsTouchedPage1('מספר_קשר1')"
                                        formControlName="מספר_קשר1"
                                        inputrestriction="basic1"
                                        matInput
                                        type="string"
                                        name="SearchDualList"
                                        class="form-control"
                                        autocomplete="off"
                                    />
                                </mat-form-field>
                                <br /><br />
                                <!-- מספר נשק (א) -->
                                <mat-form-field appearance="fill" class="form-element field-wide">
                                    <mat-label style="font-size: 1.2em">*נשק (א)</mat-label>
                                    <span matPrefix class="equipment-emoji" aria-label="weapon number" role="img">
					<fa-icon
                        size="2x"
                        class="fa-lg-icon"
                        style="color: red;"
                        [icon]="faPersonRifle"
                    ></fa-icon>
				</span>
                                    <input
                                        (focusout)="form.controls['מספר_נשק'].markAsTouched(); allControlsTouchedPage1('מספר_נשק')"
                                        formControlName="מספר_נשק"
                                        inputrestriction="basic1"
                                        matInput
                                        type="number"
                                        name="SearchDualList"
                                        class="form-control"
                                        autocomplete="off"
                                    />
                                </mat-form-field>
                                <br /><br />
                                <!-- מספר טאבלט -->
                                <mat-form-field
                                    appearance="fill"
                                    class="form-element field-wide"
                                >
                                    <mat-label style="font-size: 1.2em">*טאבלט</mat-label>
                                    <span
                                        matPrefix
                                        class="equipment-emoji"
                                        aria-label="tablet number"
                                        role="img"
                                    >
				📱
				</span>
                                    <input
                                        (focusout)="form.controls['מספר_טאבלט'].markAsTouched(); allControlsTouchedPage1('מספר_טאבלט')"
                                        formControlName="מספר_טאבלט"
                                        inputrestriction="alphanums"
                                        matInput
                                        type="text"
                                        name="SearchDualList"
                                        class="form-control"
                                        autocomplete="off"
                                    />
                                </mat-form-field>
                                <br /><br />
                                <!-- מספר קשר (ב) -->
                                <mat-form-field
                                    appearance="fill"
                                    class="form-element field-wide"
                                >
                                    <mat-label style="font-size: 1.2em">קשר (ב)</mat-label>
                                    <span
                                        matPrefix
                                        class="equipment-emoji"
                                        aria-label="radio number"
                                        role="img"
                                    >
					<fa-icon
                        size="2x"
                        class="fa-lg-icon"
                        style="color: #000000;"
                        [icon]="faWalkieTalkie"
                    ></fa-icon>
				</span>
                                    <input
                                        (focusout)="form.controls['מספר_קשר2'].markAsTouched(); allControlsTouchedPage1('מספר_קשר2')"
                                        formControlName="מספר_קשר2"
                                        inputrestriction="basic1"
                                        matInput
                                        type="string"
                                        name="SearchDualList"
                                        class="form-control"
                                        autocomplete="off"
                                    />
                                </mat-form-field>
                                <br /><br />
                                <!-- מספר נשק (ב) -->
                                <mat-form-field
                                    appearance="fill"
                                    class="form-element field-wide"
                                >
                                    <mat-label style="font-size: 1.2em">נשק (ב)</mat-label>
                                    <span matPrefix class="equipment-emoji" aria-label="weapon number" role="img">
					<fa-icon
                        size="2x"
                        class="fa-lg-icon"
                        style="color: red;"
                        [icon]="faPersonRifle"
                    ></fa-icon>
				</span>
                                    <input
                                        (focusout)="form.controls['מספר_נשק2'].markAsTouched(); allControlsTouchedPage1('מספר_נשק2')"
                                        formControlName="מספר_נשק2"
                                        inputrestriction="basic1"
                                        matInput
                                        type="number"
                                        name="SearchDualList"
                                        class="form-control"
                                        autocomplete="off"
                                    />
                                </mat-form-field>
                                <br /><br />
                                <!-- מספר טייזר -->
                                <mat-form-field
                                    appearance="fill"
                                    class="form-element field-wide"
                                >
                                    <mat-label style="font-size: 1.2em">טייזר</mat-label>
                                    <span
                                        matPrefix
                                        class="equipment-emoji"
                                        aria-label="taser number"
                                        role="img"
                                    >
					<fa-icon
                        size="2x"
                        class="fa-lg-icon"
                        style="color: #ffd300;"
                        [icon]="faGun"
                    ></fa-icon>
				</span>
                                    <input
                                        (focusout)="form.controls['מספר_טייזר'].markAsTouched(); allControlsTouchedPage1('מספר_טייזר')"
                                        formControlName="מספר_טייזר"
                                        inputrestriction="alphanums"
                                        matInput
                                        type="text"
                                        name="SearchDualList"
                                        class="form-control"
                                        autocomplete="off"
                                    />
                                </mat-form-field>
                                <br /><br />
                                <!-- אזיק רגליים -->
                                <mat-form-field
                                    appearance="fill"
                                    class="form-element field-wide"
                                >
                                    <mat-label style="font-size: 1.2em">אזיק רגליים</mat-label>
                                    <span
                                        matPrefix
                                        class="equipment-emoji"
                                        aria-label="leg cuffs"
                                        role="img"
                                    >
					<fa-icon
                        size="2x"
                        class="fa-lg-icon"
                        style="color: #a4a4a4;"
                        [icon]="faHandcuffs"
                    ></fa-icon>
				</span>
                                    <input
                                        (focusout)="form.controls['אזיק_רגליים'].markAsTouched(); allControlsTouchedPage1('אזיק_רגליים')"
                                        formControlName="אזיק_רגליים"
                                        inputrestriction="alphanums"
                                        matInput
                                        type="text"
                                        name="SearchDualList"
                                        class="form-control"
                                        autocomplete="off"
                                    />
                                </mat-form-field>
                            </section>
                        </div>
                        <div style="text-align: right">
                            <button
                                [disabled]="wizardDisabled1"
                                mat-raised-button
                                color="warn"
                                (click)="stepper.next(); resetFormControlsPage2()"
                            >
                                המשך
                                <mat-icon>
                                    arrow_back
                                </mat-icon>
                            </button>
                            <br />
                            <br />
                            <mat-label
                                *ngIf="lastZivud"
                                style="opacity: 0.7; padding-right: 10px; padding-left: 10px; margin-top: 20px"
                            >
                                זיווד אחרון ע"י {{ lastZivud.userName }} ב: {{ lastZivud.dateTime }}
                            </mat-label>
                        </div>
                    </mat-step>
                    <!-- Wizard Step 2: Vehicle equipment + your missing dropdowns -->
                    <mat-step [completed]="!wizardDisabled2">
                        <ng-template matStepLabel>נידת</ng-template>
                        <div
                            fxLayout="row"
                            fxLayoutAlign="center center"
                            style="position: relative; left: -16px"
                            class="largeFonts"
                        >
                            <section class="example-section">
                                <div fxLayout="column" fxLayoutAlign="center center">
                                    <!-- גשר תאורה מהבהב -->
                                    <mat-form-field
                                        class="entry1 form-element"
                                        [ngClass]="{'error-border': !form.controls['גשר_תאורה_מהבהב'].touched}"
                                    >
                                        <mat-label>גשר אור מהבהב</mat-label>
                                        <span
                                            matPrefix
                                            class="equipment-emoji"
                                            aria-label="police light"
                                            role="img"
                                        >
						🚨
						</span>
                                        <mat-select
                                            formControlName="גשר_תאורה_מהבהב"
                                            (selectionChange)="allControlsTouchedPage2('גשר_תאורה_מהבהב'); checkStartCheckReady()"
                                            [ngClass]="{
						'error-border':
						form.controls['גשר_תאורה_מהבהב'].invalid && form.controls['גשר_תאורה_מהבהב'].touched
						}"
                                        >
                                            <mat-option *ngFor="let item of ['0','1']" [value]="item">
                                                <mat-label>{{ item }}</mat-label>
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                    <!-- מחסום סטינגר דוקרנים -->
                                    <mat-form-field
                                        class="entry1 form-element"
                                        [ngClass]="{'error-border': !form.controls['מחסום_סטינגר_דוקרנים'].touched}"
                                    >
                                        <mat-label>סטינגר דוקרנים</mat-label>
                                        <span
                                            matPrefix
                                            class="equipment-emoji"
                                            aria-label="road spikes"
                                            role="img"
                                        >
						🪝
						</span>
                                        <mat-select
                                            formControlName="מחסום_סטינגר_דוקרנים"
                                            (selectionChange)="allControlsTouchedPage2('מחסום_סטינגר_דוקרנים'); checkStartCheckReady()"
                                            [ngClass]="{
						'error-border':
						form.controls['מחסום_סטינגר_דוקרנים'].invalid &&
						form.controls['מחסום_סטינגר_דוקרנים'].touched
						}"
                                        >
                                            <mat-option
                                                *ngFor="let item of ['0','1','2']"
                                                [value]="item"
                                            >
                                                <mat-label>{{ item }}</mat-label>
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                    <!-- טרפזים -->
                                    <!--                                    <mat-form-field-->
                                    <!--                                        class="entry1 form-element"-->
                                    <!--                                        [ngClass]="{'error-border': !form.controls['טרפזים'].touched}"-->
                                    <!--                                    >-->
                                    <!--                                        <mat-label>טרפזים</mat-label>-->
                                    <!--                                        <span-->
                                    <!--                                            matPrefix-->
                                    <!--                                            class="equipment-emoji"-->
                                    <!--                                            aria-label="traffic shapes"-->
                                    <!--                                            role="img"-->
                                    <!--                                        >-->
                                    <!--                                        🔺-->
                                    <!--                                    </span>-->
                                    <!--                                        <mat-select-->
                                    <!--                                            formControlName="טרפזים"-->
                                    <!--                                            (selectionChange)="allControlsTouchedPage2('טרפזים'); checkStartCheckReady()"-->
                                    <!--                                            [ngClass]="{-->
                                    <!--                                              'error-border':-->
                                    <!--                                              form.controls['טרפזים'].invalid && form.controls['טרפזים'].touched-->
                                    <!--                                            }"-->
                                    <!--                                        >-->
                                    <!--                                            <mat-option-->
                                    <!--                                                *ngFor="let item of ['0','1','2','3','4','5','6','7','8']"-->
                                    <!--                                                [value]="item"-->
                                    <!--                                            >-->
                                    <!--                                                <mat-label>{{ item }}</mat-label>-->
                                    <!--                                            </mat-option>-->
                                    <!--                                        </mat-select>-->
                                    <!--                                    </mat-form-field>-->
                                    <!-- אוהל מחסום -->
                                    <mat-form-field
                                        class="entry1 form-element"
                                        [ngClass]="{'error-border': !form.controls['אוהל_מחסום'].touched}"
                                    >
                                        <mat-label>אוהל מחסום</mat-label>
                                        <span
                                            matPrefix
                                            class="equipment-emoji"
                                            aria-label="checkpoint tent"
                                            role="img"
                                        >
						⛺
						</span>
                                        <mat-select
                                            formControlName="אוהל_מחסום"
                                            (selectionChange)="allControlsTouchedPage2('אוהל_מחסום'); checkStartCheckReady()"
                                            [ngClass]="{
						'error-border':
						form.controls['אוהל_מחסום'].invalid && form.controls['אוהל_מחסום'].touched
						}"
                                        >
                                            <mat-option
                                                *ngFor="let item of ['0','1','2']"
                                                [value]="item"
                                            >
                                                <mat-label>{{ item }}</mat-label>
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                    <!-- בדיקת אומים -->
                                    <mat-form-field
                                        class="entry1 form-element"
                                        [ngClass]="{'error-border': !form.controls['בדיקת_אומים'].touched}"
                                    >
                                        <mat-label>בדיקת אומים</mat-label>
                                        <span
                                            matPrefix
                                            class="equipment-emoji"
                                            aria-label="nuts check"
                                            role="img"
                                        >
						⚙️
						</span>
                                        <mat-select
                                            formControlName="בדיקת_אומים"
                                            (selectionChange)="allControlsTouchedPage2('בדיקת_אומים'); checkStartCheckReady()"
                                            [ngClass]="{
						'error-border':
						form.controls['בדיקת_אומים'].invalid && form.controls['בדיקת_אומים'].touched
						}"
                                        >
                                            <mat-option
                                                *ngFor="let item of [
						'0','1','2','3','4','5','6','7','8','9','10',
						'11','12','13','14','15','16','17','18','19','20'
						]"
                                                [value]="item"
                                            >
                                                <mat-label>{{ item }}</mat-label>
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                    <!-- מגפון -->
                                    <mat-form-field
                                        class="entry1 form-element"
                                        [ngClass]="{'error-border': !form.controls['מגפון'].touched}"
                                    >
                                        <mat-label>מגפון</mat-label>
                                        <span
                                            matPrefix
                                            class="equipment-emoji"
                                            aria-label="megaphone"
                                            role="img"
                                        >
						📢
						</span>
                                        <mat-select
                                            formControlName="מגפון"
                                            (selectionChange)="allControlsTouchedPage2('מגפון'); checkStartCheckReady()"
                                            [ngClass]="{
						'error-border':
						form.controls['מגפון'].invalid && form.controls['מגפון'].touched
						}"
                                        >
                                            <mat-option *ngFor="let item of ['0','1']" [value]="item">
                                                <mat-label>{{ item }}</mat-label>
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                    <!-- מתודלקת -->
                                    <mat-form-field
                                        class="entry1 form-element"
                                        [ngClass]="{'error-border': !form.controls['מתודלקת'].touched}"
                                    >
                                        <mat-label>מתודלקת</mat-label>
                                        <span
                                            matPrefix
                                            class="equipment-emoji"
                                            aria-label="fuel gauge"
                                            role="img"
                                        >
						⛽
						</span>
                                        <mat-select
                                            formControlName="מתודלקת"
                                            (selectionChange)="allControlsTouchedPage2('מתודלקת'); checkStartCheckReady()"
                                            [ngClass]="{
						'error-border':
						form.controls['מתודלקת'].invalid && form.controls['מתודלקת'].touched
						}"
                                        >
                                            <mat-option
                                                *ngFor="let item of [
						'0%',
						'10%',
						'20%',
						'30%',
						'40%',
						'50%',
						'60%',
						'70%',
						'80%',
						'90%',
						'100%'
						]"
                                                [value]="item"
                                            >
                                                <mat-label>{{ item }}</mat-label>
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                            </section>
                            <section class="example-section">
                                <div fxLayout="column" fxLayoutAlign="center center" style="padding-left: 20px">
                                    <!-- חומ"ס -->
                                    <mat-form-field
                                        class="entry1 form-element"
                                        [ngClass]="{'error-border': !form.controls['חומס'].touched}"
                                    >
                                        <mat-label>חומ"ס</mat-label>
                                        <span
                                            matPrefix
                                            class="equipment-emoji"
                                            aria-label="hazardous material"
                                            role="img"
                                        >
						☣️
						</span>
                                        <mat-select
                                            formControlName="חומס"
                                            (selectionChange)="allControlsTouchedPage2('חומס'); checkStartCheckReady()"
                                            [ngClass]="{
						'error-border':
						form.controls['חומס'].invalid && form.controls['חומס'].touched
						}"
                                        >
                                            <mat-option
                                                *ngFor="let item of ['0','1','2']"
                                                [value]="item"
                                            >
                                                <mat-label>{{ item }}</mat-label>
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                    <!-- נצנצים קיימים -->
                                    <!--                                    <mat-form-field-->
                                    <!--                                        class="entry1 form-element"-->
                                    <!--                                        [ngClass]="{'error-border': !form.controls['נצנצים_קימים'].touched}"-->
                                    <!--                                    >-->
                                    <!--                                        <mat-label>נצנץ קיים</mat-label>-->
                                    <!--                                        <span-->
                                    <!--                                            matPrefix-->
                                    <!--                                            class="equipment-emoji"-->
                                    <!--                                            aria-label="existing strobe"-->
                                    <!--                                            role="img"-->
                                    <!--                                        >-->
                                    <!--                                        ✨-->
                                    <!--                                    </span>-->
                                    <!--                                        <mat-select-->
                                    <!--                                            formControlName="נצנצים_קימים"-->
                                    <!--                                            (selectionChange)="changeMaxNaznaz($event); allControlsTouchedPage2('נצנצים_קימים'); checkStartCheckReady(); createReport()"-->
                                    <!--                                            [ngClass]="{-->
                                    <!--                                              'error-border':-->
                                    <!--                                              form.controls['נצנצים_קימים'].invalid && form.controls['נצנצים_קימים'].touched-->
                                    <!--                                            }"-->
                                    <!--                                        >-->
                                    <!--                                            <mat-option-->
                                    <!--                                                *ngFor="let item of ['0','1','2','3','4','5','6']"-->
                                    <!--                                                [value]="item"-->
                                    <!--                                            >-->
                                    <!--                                                <mat-label>{{ item }}</mat-label>-->
                                    <!--                                            </mat-option>-->
                                    <!--                                        </mat-select>-->
                                    <!--                                    </mat-form-field>-->
                                    <!-- נצנצים טעונים -->
                                    <mat-form-field
                                        class="entry1 form-element"
                                        [ngClass]="{'error-border': !form.controls['נצנצים_טעונים'].touched}"
                                    >
                                        <mat-label>נצנץ טעון</mat-label>
                                        <span
                                            matPrefix
                                            class="equipment-emoji"
                                            aria-label="charged strobe"
                                            role="img"
                                        >
						🔋
						</span>
                                        <mat-select
                                            formControlName="נצנצים_טעונים"
                                            (selectionChange)="allControlsTouchedPage2('נצנצים_טעונים'); checkStartCheckReady(); createReport()"
                                            [ngClass]="{
						'error-border':
						form.controls['נצנצים_טעונים'].invalid && form.controls['נצנצים_טעונים'].touched
						}"
                                        >
                                            <mat-option
                                                *ngFor="let item of maxNaznaz"
                                                [value]="item"
                                            >
                                                <mat-label>{{ item }}</mat-label>
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                    <!-- סס"ל -->
                                    <mat-form-field
                                        class="entry1 form-element"
                                        [ngClass]="{'error-border': !form.controls['ססל'].touched}"
                                    >
                                        <mat-label>סס"ל</mat-label>
                                        <span
                                            matPrefix
                                            class="equipment-emoji"
                                            aria-label="pepper spray or similar"
                                            role="img"
                                        >
						📏
						</span>
                                        <mat-select
                                            formControlName="ססל"
                                            (selectionChange)="allControlsTouchedPage2('ססל'); checkStartCheckReady()"
                                            [ngClass]="{
						'error-border':
						form.controls['ססל'].invalid && form.controls['ססל'].touched
						}"
                                        >
                                            <mat-option
                                                *ngFor="let item of ['0','1','2','3','4','5']"
                                                [value]="item"
                                            >
                                                <mat-label>{{ item }}</mat-label>
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                    <!-- יריעה לגופה -->
                                    <mat-form-field
                                        class="entry1 form-element"
                                        [ngClass]="{'error-border': !form.controls['יריעה_לגופה'].touched}"
                                    >
                                        <mat-label>יריעה לגופה</mat-label>
                                        <span
                                            matPrefix
                                            class="equipment-emoji"
                                            aria-label="body sheet"
                                            role="img"
                                        >
						💀
						</span>
                                        <mat-select
                                            formControlName="יריעה_לגופה"
                                            (selectionChange)="allControlsTouchedPage2('יריעה_לגופה'); checkStartCheckReady()"
                                            [ngClass]="{
						'error-border':
						form.controls['יריעה_לגופה'].invalid && form.controls['יריעה_לגופה'].touched
						}"
                                        >
                                            <mat-option
                                                *ngFor="let item of ['0','1','2']"
                                                [value]="item"
                                            >
                                                <mat-label>{{ item }}</mat-label>
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                    <!-- סדר -->
                                    <mat-form-field
                                        class="entry1 form-element"
                                        [ngClass]="{'error-border': !form.controls['סדר'].touched}"
                                    >
                                        <mat-label>סדר</mat-label>
                                        <span
                                            style="position: relative; top: 10px"
                                            matPrefix
                                            class="equipment-emoji"
                                            aria-label="storm gear"
                                            role="img"
                                        >
						🧹
						</span>
                                        <mat-select
                                            formControlName="סדר"
                                            (selectionChange)="allControlsTouchedPage2('סדר'); checkStartCheckReady()"
                                            [ngClass]="{
						'error-border':
						form.controls['סדר'].invalid && form.controls['סדר'].touched
						}"
                                        >
                                            <mat-option
                                                *ngFor="let item of ['נקיה','מלוכלכת','?']"
                                                [value]="item"
                                            >
                                                <mat-label>{{ item }}</mat-label>
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                    <!-- חליפת סערה -->
                                    <mat-form-field
                                        class="entry1 form-element"
                                        [ngClass]="{'error-border': !form.controls['חליפת_סערה'].touched}"
                                    >
                                        <mat-label>חליפת סערה</mat-label>
                                        <span
                                            matPrefix
                                            class="equipment-emoji"
                                            aria-label="storm gear"
                                            role="img"
                                        >
						🧥
						</span>
                                        <mat-select
                                            formControlName="חליפת_סערה"
                                            (selectionChange)="allControlsTouchedPage2('חליפת_סערה'); checkStartCheckReady()"
                                            [ngClass]="{
						'error-border':
						form.controls['חליפת_סערה'].invalid && form.controls['חליפת_סערה'].touched
						}"
                                        >
                                            <mat-option
                                                *ngFor="let item of ['0','1','2']"
                                                [value]="item"
                                            >
                                                <mat-label>{{ item }}</mat-label>
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                            </section>
                        </div>
                        <div class="checkboxesCollection" fxLayout="row" fxLayoutAlign="center start">
                            <!-- LEFT CHECKBOX GROUP WITH MASTER CHECKBOX -->
                            <section style="margin-right: 30px;">
                                <!-- Master checkbox for LEFT group (tri-state) -->
                                <mat-checkbox
                                    class="master-toggle"
                                    [checked]="isGroupAllChecked('left')"
                                    [indeterminate]="isGroupIndeterminate('left')"
                                    (change)="masterToggleGroup('left', $event.checked)"
                                >
                                    סמון הכל
                                </mat-checkbox>
                                <br />
                                <!-- Child checkboxes (no [indeterminate]="true") -->
                                <mat-checkbox
                                    (change)="allControlsTouchedPage2('ערכת_עזרה_ראשונה')"
                                    formControlName="ערכת_עזרה_ראשונה"
                                >
                                    <mat-label
                                        [ngClass]="{'error-border-wrapper': !form.controls['ערכת_עזרה_ראשונה'].touched}"
                                        class="sliderLabel"
                                    >
                                        ערכת עזרה ראשונה
                                    </mat-label>
                                </mat-checkbox>
                                <br />
                                <mat-checkbox
                                    (change)="allControlsTouchedPage2('מטף_כיבוי_לרכב')"
                                    formControlName="מטף_כיבוי_לרכב"
                                >
                                    <mat-label
                                        [ngClass]="{'error-border-wrapper': !form.controls['מטף_כיבוי_לרכב'].touched}"
                                        class="sliderLabel"
                                    >
                                        מטף כיבוי לרכב
                                    </mat-label>
                                </mat-checkbox>
                                <br />
                                <mat-checkbox
                                    (change)="allControlsTouchedPage2('מערכת_קשר')"
                                    formControlName="מערכת_קשר"
                                >
                                    <mat-label
                                        [ngClass]="{'error-border-wrapper': !form.controls['מערכת_קשר'].touched}"
                                        class="sliderLabel"
                                    >
                                        מערכת קשר תקינה
                                    </mat-label>
                                </mat-checkbox>
                                <br />
                                <mat-checkbox
                                    (change)="allControlsTouchedPage2('מערכת_כריזה')"
                                    formControlName="מערכת_כריזה"
                                >
                                    <mat-label
                                        [ngClass]="{'error-border-wrapper': !form.controls['מערכת_כריזה'].touched}"
                                        class="sliderLabel"
                                    >
                                        מערכת כריזה תקינה
                                    </mat-label>
                                </mat-checkbox>
                                <br />
                                <mat-checkbox
                                    (change)="allControlsTouchedPage2('מגבה_לרכב_ידית_מפתח')"
                                    formControlName="מגבה_לרכב_ידית_מפתח"
                                >
                                    <mat-label
                                        [ngClass]="{'error-border-wrapper': !form.controls['מגבה_לרכב_ידית_מפתח'].touched}"
                                        class="sliderLabel"
                                    >
                                        מגבה ידית מפתח
                                    </mat-label>
                                </mat-checkbox>
                                <br />
                                <mat-checkbox
                                    (change)="allControlsTouchedPage2('גלגל_ספייר')"
                                    formControlName="גלגל_ספייר"
                                >
                                    <mat-label
                                        [ngClass]="{'error-border-wrapper': !form.controls['גלגל_ספייר'].touched}"
                                        class="sliderLabel"
                                    >
                                        גלגל ספייר
                                    </mat-label>
                                </mat-checkbox>
                                <br />
                                <mat-checkbox
                                    (change)="allControlsTouchedPage2('אפודה_זוהרת')"
                                    formControlName="אפודה_זוהרת"
                                >
                                    <mat-label
                                        [ngClass]="{'error-border-wrapper': !form.controls['אפודה_זוהרת'].touched}"
                                        class="sliderLabel"
                                    >
                                        אפודה זוהרת
                                    </mat-label>
                                </mat-checkbox>
                                <br />
                                <mat-checkbox
                                    (change)="allControlsTouchedPage2('משולש_אזהרה')"
                                    formControlName="משולש_אזהרה"
                                >
                                    <mat-label
                                        [ngClass]="{'error-border-wrapper': !form.controls['משולש_אזהרה'].touched}"
                                        class="sliderLabel"
                                    >
                                        משולש אזהרה
                                    </mat-label>
                                </mat-checkbox>
                            </section>
                            <!-- RIGHT CHECKBOX GROUP WITH MASTER CHECKBOX -->
                            <section>
                                <!-- Master checkbox for RIGHT group (tri-state) -->
                                <mat-checkbox
                                    class="master-toggle"
                                    [checked]="isGroupAllChecked('right')"
                                    [indeterminate]="isGroupIndeterminate('right')"
                                    (change)="masterToggleGroup('right', $event.checked)"
                                >
                                    סמון הכל
                                </mat-checkbox>
                                <br />
                                <!-- Child checkboxes (no [indeterminate]="true") -->
                                <mat-checkbox
                                    (change)="allControlsTouchedPage2('עמדת_עריסה')"
                                    formControlName="עמדת_עריסה"
                                >
                                    <mat-label
                                        [ngClass]="{'error-border-wrapper': !form.controls['עמדת_עריסה'].touched}"
                                        class="sliderLabel"
                                    >
                                        עמדת עריסה
                                    </mat-label>
                                </mat-checkbox>
                                <br />
                                <mat-checkbox
                                    (change)="allControlsTouchedPage2('מכשיר_נייד_מיקרופון')"
                                    formControlName="מכשיר_נייד_מיקרופון"
                                >
                                    <mat-label
                                        [ngClass]="{'error-border-wrapper': !form.controls['מכשיר_נייד_מיקרופון'].touched}"
                                        class="sliderLabel"
                                    >
                                        מכשיר נייד,מיקרופון
                                    </mat-label>
                                </mat-checkbox>
                                <br />
                                <mat-checkbox
                                    (change)="allControlsTouchedPage2('מצלמת_רוורס')"
                                    formControlName="מצלמת_רוורס"
                                >
                                    <mat-label
                                        [ngClass]="{'error-border-wrapper': !form.controls['מצלמת_רוורס'].touched}"
                                        class="sliderLabel"
                                    >
                                        מצלמת רוורס
                                    </mat-label>
                                </mat-checkbox>
                                <br />
                                <mat-checkbox
                                    (change)="allControlsTouchedPage2('מדפסת_נייר')"
                                    formControlName="מדפסת_נייר"
                                >
                                    <mat-label
                                        [ngClass]="{'error-border-wrapper': !form.controls['מדפסת_נייר'].touched}"
                                        class="sliderLabel"
                                    >
                                        מדפסת נייר
                                    </mat-label>
                                </mat-checkbox>
                                <br />
                                <mat-checkbox
                                    (change)="allControlsTouchedPage2('מגבר_צופר_רמקול_מיקרופון')"
                                    formControlName="מגבר_צופר_רמקול_מיקרופון"
                                >
                                    <mat-label
                                        [ngClass]="{'error-border-wrapper': !form.controls['מגבר_צופר_רמקול_מיקרופון'].touched}"
                                        class="sliderLabel"
                                    >
                                        צופר,רמקול,מיקרופון
                                    </mat-label>
                                </mat-checkbox>
                                <br />
                                <mat-checkbox
                                    (change)="allControlsTouchedPage2('נורת_בדוק_מנוע')"
                                    formControlName="נורת_בדוק_מנוע"
                                >
                                    <mat-label
                                        [ngClass]="{'error-border-wrapper': !form.controls['נורת_בדוק_מנוע'].touched}"
                                        class="sliderLabel"
                                    >
                                        נורת מנוע תקינה
                                    </mat-label>
                                </mat-checkbox>
                                <br />
                                <mat-checkbox
                                    (change)="allControlsTouchedPage2('נורת_בדוק_מצבר')"
                                    formControlName="נורת_בדוק_מצבר"
                                >
                                    <mat-label
                                        [ngClass]="{'error-border-wrapper': !form.controls['נורת_בדוק_מצבר'].touched}"
                                        class="sliderLabel"
                                    >
                                        נורת מצבר תקינה
                                    </mat-label>
                                </mat-checkbox>
                                <br />
                                <mat-checkbox
                                    (change)="allControlsTouchedPage2('adblue')"
                                    formControlName="adblue"
                                >
                                    <mat-label
                                        [ngClass]="{'error-border-wrapper': !form.controls['adblue'].touched}"
                                        class="sliderLabel"
                                    >
                                        AdBlue נורת סולר
                                    </mat-label>
                                </mat-checkbox>
                            </section>
                        </div>
                        <div
                            fxLayout="column"
                            style="width: 100%; position: relative; left: -40px"
                        >
                            <!-- Row 1: Odometer Field + Label -->
                            <div
                                fxLayout="row"
                                fxLayoutAlign="center center"
                                fxLayoutGap="16px"
                            >
                                <div fxFlex="50">
                                    <mat-form-field style="width: 150px;">
                                        <mat-label>קילומטראז</mat-label>
                                        <input
                                            matInput
                                            type="number"
                                            formControlName="קילומטראז"
                                            inputrestriction="numbers"
                                            (focusout)="form.controls['קילומטראז'].markAsTouched(); allControlsTouchedPage2('קילומטראז')"
                                            (keyup)="allControlsTouchedPage2('קילומטראז')"
                                            autocomplete="off"
                                        />
                                    </mat-form-field>
                                </div>
                                <div fxFlex="50">
                                    <mat-label style="font-size: 1.2em;">קריאת ספידומטר</mat-label>
                                </div>
                            </div>
                            <!-- Row 2: Slide Toggle + "טיהור תא עצורים" Label -->
                            <div
                                fxLayout="row"
                                fxLayoutAlign="center center"
                                fxLayoutGap="16px"
                                style="margin-top: 16px; position: relative; left: 28px"
                            >
                                <div fxFlex="50" style="border: yellow 2px dashed; margin: 20px; padding: 20px">
                                    <div fxFlex="50">
						<span style="position: relative; top: -4px"
                              matPrefix
                              class="equipment-emoji"
                              aria-label="charged strobe"
                              role="img"
                        >  {{ form.get('טיהור_תא_עצורים')?.value ? '✅' : '⚠️' }}</span>
                                        <mat-slide-toggle
                                            formControlName="טיהור_תא_עצורים"
                                            [ngClass]="{'error-border-wrapper': !form.controls['טיהור_תא_עצורים'].touched}"
                                            (change)="allControlsTouchedPage2('טיהור_תא_עצורים')"
                                        >
                                            <mat-label style="font-size: 1.2em;">[ נבדק ]</mat-label>
                                        </mat-slide-toggle>
                                    </div>
                                    <div fxFlex="50">
                                        <mat-label style="font-size: 1.2em; padding-left: 35px">
                                            טיהור תא עצורים
                                        </mat-label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <br />
                        <br />
                        <div style="text-align: right">
                            <button
                                [disabled]="wizardDisabled2"
                                mat-raised-button
                                color="warn"
                                (click)="createReport();stepper.next()"
                            >
                                <mat-icon>arrow_back</mat-icon>
                                המשך
                            </button>
                            <br />
                            <br />
                            <mat-label
                                *ngIf="lastZivud"
                                style="opacity: 0.7; padding-right: 10px; padding-left: 10px; margin-top: 20px"
                            >
                                זיווד אחרון ע"י {{ lastZivud.userName }} ב:
                                <span style="padding-left: 4px; padding-right: 4px">
				{{ lastZivud.dateTime }}
				</span>
                            </mat-label>
                        </div>
                    </mat-step>
                    <!-- Photo Step 1 -->
                    <mat-step [completed]="!step1PhotosDisabled">
                        <ng-template matStepLabel>ציוד</ng-template>
                        <div fxLayout="row" fxLayoutAlign="center center" style="padding-bottom: 30px">
                            <mat-card class="equipment-card" dir="rtl">
                                <mat-card-header>
                                    <mat-card-title class="title">אנא צלם תמונה עדכנית:</mat-card-title>
                                </mat-card-header>
                                <img
                                    src="./assets/images/police_equipment.png"
                                    style="width: 230px; display: block;"
                                />
                                <mat-list>
                                    <mat-list-item>
                                        <mat-icon matListIcon>check_circle</mat-icon>
                                        <span class="item-text">2 אפודות קרמיות</span>
                                    </mat-list-item>
                                    <mat-list-item>
                                        <mat-icon matListIcon>check_circle</mat-icon>
                                        <span class="item-text">8 טרפזים</span>
                                    </mat-list-item>
                                    <mat-list-item>
                                        <mat-icon matListIcon>check_circle</mat-icon>
                                        <span class="item-text">6 נצנצים</span>
                                    </mat-list-item>
                                </mat-list>
                            </mat-card>
                        </div>
                        <div fxLayout="column" fxLayoutAlign="start center" fxLayoutGap="16px">
                            <div fxLayout="row" fxLayoutAlign="space-between center" style="width: 100%;">
                                <button mat-raised-button color="primary">
                                    <mat-icon>camera_alt</mat-icon>
                                    צלם ציוד
                                    <input
                                        type="file"
                                        accept="image/*"
                                        capture="environment"
                                        (change)="onFilesSelectedStep1($event)"
                                    />
                                </button>
                                <div style="text-align: right">
                                    <button mat-raised-button color="warn"
                                            (click)="stepper.next()"
                                            [disabled]="step1PhotosDisabled">
                                        המשך
                                        <mat-icon>arrow_back</mat-icon>
                                    </button>
                                </div>
                            </div>
                            <div style="padding: 8px; background-color: rgba(255, 152, 0, 0.1); border-radius: 8px; width: 100%; max-width: 400px;">
                                <mat-checkbox [(ngModel)]="useLowBandwidthMode" [ngModelOptions]="{standalone: true}" style="width: 100%;">
                                    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px">
                                        <mat-icon style="font-size: 20px; width: 20px; height: 20px; color: #ff9800;">signal_cellular_alt</mat-icon>
                                        <span style="font-size: 14px;">השתמש בתמונות קטנות (לחיבור איטי)</span>
                                    </div>
                                </mat-checkbox>
                                <div style="font-size: 11px; opacity: 0.7; padding-right: 32px; margin-top: 4px;">
                                    תמונות יהיו באיכות נמוכה יותר לצורך העלאה מהירה
                                </div>
                            </div>
                        </div>
                        <div class="images-container-snaps" *ngIf="imageDataStep1?.length > 0">
                            <div class="image-container-snaps" 
                                 *ngFor="let img of imageDataStep1; let i = index"
                                 (click)="openImagePreview(img, i, 'step1')">
                                <img [src]="img" 
                                     [alt]="'תמונת רכב ' + (i + 1)"
                                     loading="lazy" />
                                <span (click)="removeFileStep1(i); $event.stopPropagation()"
                                      title="הסר תמונה">
                                    <mat-icon>close</mat-icon>
                                </span>
                                <div class="image-overlay">
                                    <div>תמונת רכב {{i + 1}}</div>
                                    <div style="font-size: 10px; opacity: 0.8;">
                                        לחץ להגדלה
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                        <!-- Empty state when no images -->
                        <div *ngIf="!imageDataStep1?.length" 
                             style="text-align: center; padding: 40px 20px; color: #666;">
                            <mat-icon style="font-size: 48px; opacity: 0.3; margin-bottom: 16px;">
                                directions_car
                            </mat-icon>
                            <p>עדיין לא צולמו תמונות רכב</p>
                            <p style="font-size: 14px; opacity: 0.7;">
                                השתמש בכפתור המצלמה למעלה כדי לצלם
                            </p>
                        </div>
                    </mat-step>
                    <!-- Photo Step 2 -->
                    <mat-step [completed]="!step2PhotosDisabled">
                        <ng-template matStepLabel>פגיעות</ng-template>
                        <div fxLayout="row" fxLayoutAlign="space-between center">
                            <button mat-raised-button color="primary">
                                <mat-icon>camera_alt</mat-icon>
                                צלם פגיעות
                                <input
                                    type="file"
                                    accept="image/*"
                                    capture="environment"
                                    (change)="onFilesSelectedStep2($event)"
                                />
                            </button>
                            <div style="text-align: right">
                                <button mat-raised-button color="warn"
                                        (click)="stepper.next()"
                                        [disabled]="step2PhotosDisabled">
                                    המשך
                                    <mat-icon>arrow_back</mat-icon>
                                </button>
                            </div>
                        </div>
                        <div class="images-container-snaps" *ngIf="imageDataStep2?.length > 0">
                            <div class="image-container-snaps" 
                                 *ngFor="let img of imageDataStep2; let i = index"
                                 (click)="openImagePreview(img, i, 'step2')">
                                <img [src]="img" 
                                     [alt]="'פגיעה ' + (i + 1)"
                                     loading="lazy" />
                                <span (click)="removeFileStep2(i); $event.stopPropagation()"
                                      title="הסר תמונה">
                                    <mat-icon>close</mat-icon>
                                </span>
                                <div class="image-overlay">
                                    <div>פגיעה {{i + 1}}</div>
                                    <div style="font-size: 10px; opacity: 0.8;">
                                        לחץ להגדלה
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                        <!-- Empty state when no images -->
                        <div *ngIf="!imageDataStep2?.length" 
                             style="text-align: center; padding: 40px 20px; color: #666;">
                            <mat-icon style="font-size: 48px; opacity: 0.3; margin-bottom: 16px;">
                                photo_camera
                            </mat-icon>
                            <p>עדיין לא צולמו תמונות פגיעות</p>
                            <p style="font-size: 14px; opacity: 0.7;">
                                השתמש בכפתור המצלמה למעלה כדי לצלם
                            </p>
                        </div>
                    </mat-step>
                    <mat-step>
                        <ng-template matStepLabel>סיום</ng-template>
                        <div fxFlex fxLayout="column" class="wizard-type">
                            <mat-form-field
                                style="width: 100%; height: 200px"
                                appearance="fill"
                                class="my-custom-textarea"
                            >
                                <mat-label>
                                    פגיעות והערות חובת דיווח מפורט גם אם מדובר בפגיעות ישנות
                                </mat-label>
                                <textarea
                                    matInput
                                    class="hebrewAlign my-custom-textarea"
                                    cdkAutosizeMaxRows="8"
                                    rows="14"
                                    formControlName="הערות"
                                    inputrestriction="basic1"
                                    placeholder="הערות"
                                    appearance="fill"
                                    cdkTextareaAutosize
                                    #autosize="cdkTextareaAutosize"
                                    cdkAutosizeMinRows="14"
                                ></textarea>
                            </mat-form-field>
                            <hr />
                            <div *ngIf="missingEquipmentSummary.length > 0" style="text-align: right">
                                <br />
                                <p style="font-size: 1.4em; color: red">
                                    חוסרים
                                </p>
                                <p style="font-size: 1.2em" *ngFor="let product of missingEquipmentSummary">
                                    {{ product.item }}, חסר {{ product.missing }}
                                </p>
                                <hr />
                            </div>
                            <button
                                (click)="onSubmit()"
                                [disabled]="wizardDisabled1 || wizardDisabled2"
                                type="submit"
                                class="icon-button buttonBarButt"
                                mat-raised-button
                                color="primary"
                            >
                                סיום
                            </button>
                        </div>
                        <ng-template let-modal #uploadModal class="transparentDialog">
                            <div mat-dialog-content>
                                <br />
                                <br />
                                <br />
                                <div fxLayout="column" fxLayoutAlign="center center">
                                    <div>
                                        <app-loading [type]="9" [size]="'40px'"></app-loading>
                                    </div>
                                    <div style="margin: 5px">
                                        {{ formattedUploadingSize }} / {{ formattedTotalSize }}
                                    </div>
                                    <div>
                                        <circle-progress
                                            [percent]="uploadPercentage"
                                            [maxPercent]="100"
                                            [radius]="50"
                                            [outerStrokeColor]="'#78C000'"
                                            [innerStrokeColor]="'#C7E596'"
                                            [animationDuration]="300"
                                            [showSubtitle]="false"
                                            [showUnits]="true"
                                            [showTitle]="true"
                                            [unitsColor]="'#FFFFFF'"
                                            [titleColor]="'#FFFFFF'"
                                            [titleFontWeight]="'400'"
                                            [startFromZero]="false"
                                        ></circle-progress>
                                    </div>
                                </div>
                                <br />
                                <br />
                            </div>
                        </ng-template>
                    </mat-step>
                </mat-horizontal-stepper>
            </form>
        }
        @case (EnumViewMode.COMPLETED) {
            <!-- your-component.component.html -->
            <div translate="no">
                <!-- Original summary section -->
                <div
                    fxLayout="column"
                    fxLayoutAlign="center center"
                    style="padding-top: 50px"
                >
                    <mat-label style="font-size: 3em">
                        משמרת נעימה
                    </mat-label>
                    <mat-label style="font-size: 2em">
                        ❤️🚓
                    </mat-label>
                    <br />
                    <br />
                    <mat-divider style="width: 100%; margin: 16px 0;"></mat-divider>
                    <br />
                    <br />
                    <mat-label style="font-size: 20px">
                        סיכום ציוד
                    </mat-label>
                    <div style="padding: 10px; margin: 10px; user-select: text">
                        <table
                            #summary
                            mat-table
                            [dataSource]="equipmentSummary"
                            class="mat-elevation-z8 my-table"
                        >
                            <ng-container matColumnDef="name">
                                <th mat-header-cell *matHeaderCellDef class="my-header">
                                    ציוד
                                </th>
                                <td mat-cell *matCellDef="let element" class="my-cell">
                                    {{ element.name }}
                                </td>
                            </ng-container>
                            <ng-container matColumnDef="value">
                                <th mat-header-cell *matHeaderCellDef class="my-header">
                                    מספר
                                </th>
                                <td mat-cell *matCellDef="let element" class="my-cell">
                                    {{ element.value }}
                                </td>
                            </ng-container>
                            <tr
                                mat-header-row
                                *matHeaderRowDef="displayedColumns"
                                class="my-header-row"
                            ></tr>
                            <tr
                                mat-row
                                *matRowDef="let row; columns: displayedColumns;"
                                class="my-row"
                            ></tr>
                        </table>
                        <div style="margin-top: 20px;">
                            <button mat-raised-button color="warn" (click)="copyTable()">
                                <mat-icon>content_copy</mat-icon>
                                העתק והדבק לוואטסאפ
                            </button>
                        </div>
                    </div>
                </div>

                <mat-divider></mat-divider>
                <form
                    [formGroup]="secondTabForm"
                    (ngSubmit)="onSecondTabSubmit()"
                    fxLayout="column"
                    fxLayoutAlign="start center"
                    style="
		padding: 20px;
		max-width: 400px;
		margin: 40px auto;
		font-size: 2em;
		"
                >
                    <mat-label style="font-size: 20px">
                        סיכום סוף משמרת
                    </mat-label>
                    <mat-form-field
                        appearance="fill"
                        style="width: 100%; font-size: inherit;"
                    >
                        <mat-label style="font-size: inherit;">אירועים 🚨</mat-label>
                        <mat-select
                            formControlName="drop1"
                            style="font-size: inherit;"
                        >
                            <mat-option
                                *ngFor="let num of numberOptions"
                                [value]="num"
                                style="font-size: inherit;"
                            >
                                {{ num }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                    <!-- רכבים 🚗 -->
                    <mat-form-field
                        appearance="fill"
                        style="width: 100%; font-size: inherit;"
                    >
                        <mat-label style="font-size: inherit;">רכבים 🚗</mat-label>
                        <mat-select
                            formControlName="drop2"
                            style="font-size: inherit;"
                        >
                            <mat-option
                                *ngFor="let num of numberOptions"
                                [value]="num"
                                style="font-size: inherit;"
                            >
                                {{ num }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                    <!-- דו-גלגלי 🛴 -->
                    <mat-form-field
                        appearance="fill"
                        style="width: 100%; font-size: inherit;"
                    >
                        <mat-label style="font-size: inherit;">דו-גלגלי 🛴</mat-label>
                        <mat-select
                            formControlName="drop3"
                            style="font-size: inherit;"
                        >
                            <mat-option
                                *ngFor="let num of numberOptions"
                                [value]="num"
                                style="font-size: inherit;"
                            >
                                {{ num }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                    <!-- אדם 🧍 -->
                    <mat-form-field
                        appearance="fill"
                        style="width: 100%; font-size: inherit;"
                    >
                        <mat-label style="font-size: inherit;">אדם 🧍</mat-label>
                        <mat-select
                            formControlName="drop4"
                            style="font-size: inherit;"
                        >
                            <mat-option
                                *ngFor="let num of numberOptions"
                                [value]="num"
                                style="font-size: inherit;"
                            >
                                {{ num }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                    <!-- הערות 📝 -->
                    <mat-form-field
                        appearance="fill"
                        style="width: 100%; font-size: inherit;"
                    >
                        <mat-label style="font-size: inherit;">הערות 📝</mat-label>
                        <textarea
                            matInput
                            formControlName="comments"
                            rows="4"
                            placeholder="הקלד כאן הערות..."
                            style="font-size: inherit;"
                        ></textarea>
                    </mat-form-field>
                    <!-- Copy-to-clipboard button -->
                    <div style="margin-top: 20px;">
                        <button
                            mat-raised-button
                            color="warn"
                            (click)="copyForm()"
                            style="font-size: inherit;"
                        >
                            <mat-icon style="font-size: inherit;">content_copy</mat-icon>
                            העתק והדבק לוואטסאפ
                        </button>
                    </div>
                </form>

                <br />
                <br />
                <br />
                <mat-divider style="padding-top: 20px"></mat-divider>
                <br />
                <div fxLayout="row" fxLayoutAlign="center center">
                    <a class="openGateButton" mat-raised-button href="tel:0543570197">
                        <mat-icon>fast_rewind</mat-icon>
                        פתח שער כניסה
                    </a>
                    <a class="openGateButton" mat-raised-button href="tel:0549427839">
                        <mat-icon>fast_forward</mat-icon>
                        פתח שער יציאה
                    </a>
                </div>
                <br />
                <br />

                <mat-divider></mat-divider>
                <div fxLayout="row" fxLayoutAlign="center center">
                    <button
                        (click)="reload()"
                        style="margin: 30px; padding: 30px; width: 500px"
                        mat-stroked-button
                    >
                        <mat-icon>local_police</mat-icon>
                        זיווד חדש
                    </button>
                </div>
            </div>
        }
    }
</div>
<ng-template let-modal #problemSaving>
    <h1 class="header" mat-dialog-title cdkDrag cdkDragRootElement=".cdk-overlay-pane">
        <div class="dlg-drag-handle" cdkDragHandle>
            <svg width="24px" fill="currentColor" viewBox="0 0 24 24">
                <path
                    d="M10 9h4V6h3l-5-5-5 5h3v3zm-1 1H6V7l-5 5 5 5v-3h3v-4zm14 2l-5-5v3h-3v4h3v3l5-5zm-9 3h-4v3H7l5 5 5-5h-3v-3z">
                </path>
                <path d="M0 0h24v24H0z" fill="none"></path>
            </svg>
        </div>
    </h1>
    <div mat-dialog-content>
        <div fxLayout="column" fxLayoutAlign="center center" style="text-align: right; font-size: 1.2em">
            נתקלנו בבעיה בשמירת הנתונים, בבקשה צלמו שוב את הניידת ושימרו פעם נוספת
            <br />
            <mat-icon style="font-size: 2em; width: 100px; height: 100px; padding: 20px">error</mat-icon>
        </div>
        <br />
        <br />
    </div>
</ng-template>
